import angular from 'angular';

function ErrorsFactory() {
  return class ErrorsModel {
    constructor(data = {}) {
      this.data = data;
    }
  }
}

export default angular.module('models.errors', [])
  .factory('ErrorsFactory', ErrorsFactory)
  .service('Errors', ['ErrorsFactory', ErrorsFactory => new ErrorsFactory()])
  .name;



// WEBPACK FOOTER //
// ./project/models/errors.js